// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const OrgavitazMultivitamin = {
  productCode: "SBOVZ Multivitamin",
  productName: "Orgavitaz Multivitamin",
  ingredients: "Allium sativum, Dacus carota, Mushrooms, Helianthus annuus, Moringa oleifera, Murraya Koenigii, Spinacia oleraceae, Lichens, Phyllanthus emblica, Petroselinum crispum",
  overview:"Orgavitaz Multivitamin is a blend of broad-spectrum vitamins-rich extracts from organic greens and fruits standardized for Vitamins and Minerals in its naturally existing form that can control the way body recognizes, metabolises and absorbs them for bodily functions. The product is standardized for addressing RDA levels and overall health. The food-based blend is fully natural and vegan.",
  assay:"",
  coNutrients:"Orgavitaz brings together a range of secondary metabolites like polyphenols, bio-flavonoids, lentinans, Catechins, Flavoproteins, and other carotenoids that facilitate vitamin function. ",
  studies:"Comprehensive Stability studies, Documentation for establishing right packaging and label claims.",
  benefits:"Orgavitaz Multivitamin brings variations to accommodate age, physiological changes and metabolic conditions and offer equivalents of certain less available vitamins through vegan sources.",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-1.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-3.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-4.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-5.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-6.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-7.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-8.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-9.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-10.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-11.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-12.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-13.png",
    "images/Portfolio/OrgavitazForDeficiencies/OrgavitazMultivitamin/Multivitamin-14.png",
   



  ],
  certificates: [
   "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default OrgavitazMultivitamin;
